export const loadDropdowns = () => {
  document.querySelectorAll('.form__select').forEach((div) => {
    new Dropdown(div);
  });
};

class Dropdown {
  constructor(div) {
    this.elements = { real: {}, virtual: {} };
    this.elements.parent = div;
    this.elements.virtual.select = div.querySelector('select');
    this.setupVirtualForm();
    this.active = false;
    document.addEventListener('click', this.click);
  }

  setupVirtualForm = () => {
    this.elements.virtual.select.classList.add('form__select--hidden');

    let html = `<div class='dropdown'><ul class='dropdown__list'>`;
    this.elements.virtual.select.querySelectorAll('option').forEach((o, i) => {
      html += `<li data-form-value='${o.value}' class='dropdown__item${i === 0 ? ' selected' : ''}'>${o.innerText}</li>`;
    });
    html += `<div class='dropdown__caret'></div></ul></div>`;
    this.elements.parent.insertAdjacentHTML('beforeend', html);
    this.elements.real.parent = this.elements.parent.lastChild;
    this.setSelected(this.elements.real.parent.querySelector('.dropdown__list').firstChild);
  };

  setSelected = (element) => {
    if (this.selected) {
      this.selected.element.classList.remove('selected');
    }
    element.classList.add('selected');
    const optionName = element.dataset.formValue;
    this.selected = {
      element,
      optionName,
    };
    this.elements.virtual.select.querySelectorAll('option').forEach((o, i) => {
      if (o.value === optionName) this.elements.virtual.select.selectedIndex = i;
    });
  };

  click = (e) => {
    if (!this.active) {
      if (!this.elements.real.parent.contains(e.target) && e.target !== this.elements.real.parent) return;
    } else {
      if (e.target.classList.contains('dropdown__item')) this.setSelected(e.target);
    }
    this.elements.real.parent.classList.toggle('active');
    this.active = !this.active;
  };
}
